import {
  fetchDepartmentsList,
  fetchDesignationsList,
  fetchEmployeesList,
  fetchAllRoles,
  searchEmployees,
  fetchCountriesList,
  fetchProvincesByCountry,
  fetchCitiesByProvince,
  checkIfEmailExists,
  creatNewEmployee,
  updateEmployee,
  uploadProfilePic,
  uploadEmployeeDocument,
} from "../../services/axios/apiManager";
import { toast } from "sonner";
import { handleErrors } from "../../services/dataManager";

// // // Get All Employees List
export const fetchEmployees = async (
  setEmployees,
  pagination,
  setPagination,
  navigate
) => {
  const res = await fetchEmployeesList(
    pagination.currentPage || 1,
    pagination?.pageSize || 20
  );
  if (res?.data?.success && res?.data?.data) {
    setEmployees(res.data.data);
    if (res?.data?.pagination) {
      setPagination(res.data.pagination);
    }
  } else {
    await handleErrors(res, navigate);
  }
};

// // // Search Employees by name and email

export const handleSearchByName = async (
  e,
  setEmployees,
  setQuery,
  pagination,
  setPagination,
  navigate
) => {
  const string = e.target.value;
  setQuery(string);
  if (string.length > 0) {
    const res = await searchEmployees(string);
    if (res?.data?.success && res?.data?.data) {
      setEmployees(res.data.data);
    } else {
      await handleErrors(res, navigate);
    }
  } else {
    await fetchEmployees(setEmployees, pagination, setPagination);
  }
};

// // // Get All Designations List
export const fetchDesignations = async (setDesignations, navigate) => {
  const res = await fetchDesignationsList();
  if (res?.data?.success && res?.data?.data) {
    setDesignations(res.data.data);
  } else {
    await handleErrors(res, navigate);
  }
};

// // // Get All Departments List
export const fetchDepartments = async (setDepartments, navigate) => {
  const res = await fetchDepartmentsList();
  if (res?.data?.success && res?.data?.data) {
    setDepartments(res.data.data);
  } else {
    await handleErrors(res, navigate);
  }
};

// // //Fetching All Roles List
export const fetchRoles = async (setRoles, navigate) => {
  const res = await fetchAllRoles();
  if (res?.data?.success && res?.data?.data) {
    setRoles(res.data.data);
  } else {
    await handleErrors(res, navigate);
  }
};

// // // Applying Filters
export const changeFilters = async (e, setFilters, filters) => {
  const event = e.target;
  const temp = { ...filters };
  temp[event.name] = event.value;
  if (event.name === "desId" && event?.value?.length > 0) {
    temp[event.name] = event.value;
    delete temp.depId;
    delete temp.roleId;
  } else if (event.name === "depId" && event?.value?.length > 0) {
    temp[event.name] = event.value;
    delete temp.desId;
    delete temp.roleId;
  } else if (event.name === "roleId" && event?.value?.length > 0) {
    temp[event.name] = event.value;
    delete temp.depId;
    delete temp.desId;
  } else {
    temp[event.name] = event.value;
  }
  setFilters(temp);
  return temp;
};

export const applyFilters = async (
  filters,
  setEmployees,
  pagination,
  setPagination
) => {
  const filtersString = Object.entries(filters)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  const res = await fetchEmployeesList(
    pagination.currentPage,
    pagination.pageSize,
    filtersString
  );
  if (res?.data?.data) {
    setEmployees(res.data.data);
  }
  if (res?.data?.pagination) {
    setPagination(res.data.pagination);
  }
};

export const clearFilters = async (
  filters,
  setFilters,
  setEmployees,
  pagination,
  setPagination,
  setQuery
) => {
  setQuery("");
  const temp = { ...filters };
  delete temp.depId;
  delete temp.roleId;
  delete temp.desId;
  temp.status = 3;
  setFilters(temp);
  await fetchEmployees(setEmployees, pagination, setPagination);
};

export const getCountries = async (setCountries, navigate) => {
  const res = await fetchCountriesList(1, 1000);
  if (res?.data?.success && res?.data?.data) {
    setCountries(res.data.data);
  } else {
    handleErrors(res, navigate, "Countries list:");
  }
};

export const getProvinces = async (cId, setProvinces, navigate) => {
  const res = await fetchProvincesByCountry(cId);
  if (res?.data?.success && res?.data?.data) {
    setProvinces(res.data.data);
  } else {
    handleErrors(res, navigate, "Provinces list:");
  }
};

export const getCities = async (pId, setCities, navigate) => {
  const res = await fetchCitiesByProvince(pId);
  if (res?.data?.success && res?.data?.data) {
    setCities(res.data.data);
  } else {
    handleErrors(res, navigate, "Cities list:");
  }
};

export const haveToCheckEmail = async (empData, empEmail, navigate) => {
  try {
    if (empEmail === empData.email) {
      return false;
    }
    const res = await checkIfEmailExists({ email: empData.email });
    if (res?.data?.success) {
      return res.data.data;
    } else {
      handleErrors(res, navigate, "Validating Email:");
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const saveEmployeeData = async (
  employeeId,
  employee,
  empDocs,
  image,
  navigate,
  setEmpData,
  activeTab
) => {
  // // // Update an Employee
  if (employeeId) {
    const updateRes = await updateEmployeeById(employee, employeeId, navigate);
    if (updateRes) {
      if (image) {
        await addUpdateProfilePic(employeeId, image, navigate);
      }
      if (empDocs?.document) {
        await saveDocuments(employeeId, empDocs, navigate);
      }
    }
    // // // Create an Employee
  } else {
    const empId = await createEmployee(employee, navigate, setEmpData);
    if (empId) {
      navigate(`/AddEditEmployee/${activeTab}/${empId}`, { replace: true });
      if (image) {
        await addUpdateProfilePic(empId, image, navigate);
      }
      if (empDocs?.document?.length > 0) {
        await saveDocuments(empId, empDocs, navigate);
      }
    }
  }
};

const createEmployee = async (data, navigate,setEmpData) => {
  const res = await creatNewEmployee(data);
  if (res?.data?.success && res?.data?.data) {
    setEmpData(res.data.data);
    toast.success("New Employee record has been created", { duration: 2000 });
    const id = res?.data?.data?.id;
    return id;
  } else {
    handleErrors(res, navigate);
    return null;
  }
};

const updateEmployeeById = async (data, employeeId, navigate) => {
  delete data.id;
  delete data.password;
  const res = await updateEmployee(employeeId, data);
  if (res?.data?.success) {
    toast.success("Employee record has been updated", { duration: 2000 });
    return res.data.success;
  } else {
    handleErrors(res, navigate);
    return false;
  }
};

export const addUpdateProfilePic = async (empId, img, navigate) => {
  const formData = new FormData();
  formData.append("image", img);
  const res = await uploadProfilePic(empId, formData);
  if (res?.data.success) {
    toast.success("Profile picture has been uploaded", { duration: 2000 });
  } else {
    handleErrors(res, navigate);
  }
};

const saveDocuments = async (empId, docData, navigate) => {
  const formData = new FormData();
  formData.append("documentName", docData.documentName);
  formData.append("documentType", docData.documentType);
  formData.append("document", docData.document);
  formData.append("remarks", docData.remarks);
  const res = await uploadEmployeeDocument(empId, formData);
  if (res?.data.success) {
    toast.success("Document has been uploaded", { duration: 2000 });
  } else {
    handleErrors(res, navigate, "Upload-Documents");
  }
};
